import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

import { styles } from './styles';

const useStyles = makeStyles(styles);

const ContactLink = ({ scheme, value, className }) => {
  const classes = useStyles();

  if (!value) return <span className={classnames(classes.empty, className)}>&mdash;</span>;

  return (
    <a className={classnames(classes.link, className)} href={`${scheme}:${value}`}>
      {value}
    </a>
  );
};

ContactLink.propTypes = {
  scheme: PropTypes.oneOf(['tel', 'mailto']).isRequired,
  value: PropTypes.string,
  className: PropTypes.string,
};

ContactLink.defaultProps = {
  value: '',
  className: undefined,
};

export default ContactLink;
